import { put, call, takeEvery, select } from 'redux-saga/effects';

import customerAPI from '../../api/customer';
import { Types, Creators } from '../../reducers/customer';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* customerOrderFreightRequest({ order }) {
  try {
    const token = yield select(getToken);
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const freight = yield call(customerAPI.orderInformations, order.hash, 'frete', token, siteId);

    yield put(Creators.customerOrderFreightSuccess([{ id: order.id, freight, freightError: false }], order.id));
  } catch (error) {
    yield put(Creators.customerOrderFreightFailed([{ id: order.id, freightError: true }], order.id));
  }
}

export default function* watch() {
  yield takeEvery(Types.CUSTOMER_ORDER_FREIGHT_REQUEST, customerOrderFreightRequest);
}
